import styled from 'styled-components'
import { withBox } from 'components/Box'
import { baseInputStyles, borderInputStyle, InputProps } from 'components/Input'

const StyledTextArea = styled(withBox('textarea'))<InputProps>`
  ${baseInputStyles};
  ${borderInputStyle};
`

export default StyledTextArea
